import {useId,type ReactNode} from 'react'
import {SectionHeader} from './section-header'

/** Shared read-only information card. Fields use DetailFact for one label/value treatment. */
export function DetailSection({title,meta,actions,notice,children}:{
  title:string
  meta?:ReactNode
  actions?:ReactNode
  notice?:ReactNode
  children:ReactNode
}){
  const id=useId()
  return <section aria-labelledby={id} className="rounded-token-card bg-surface-card px-6 py-4">
    <SectionHeader id={id} title={title} meta={meta} actions={actions}/>
    {notice!==undefined&&<div className="mt-4">{notice}</div>}
    <dl className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2">{children}</dl>
  </section>
}
